import React from 'react';
import Skeleton from "components/skeletons/Skeleton";
import Row from "reactstrap/es/Row";
import './myReportTicketsStyle.css'
import SkeletonCharts from "components/skeletons/SkeletonCharts";

const MyTicketSkeleton = ({type}) => {
    return (
        <Skeleton>
            <Row className={'mainSkeleton-reports'}>

                {/*<SkeletonCharts type={'fas fa-chart-area'}/>*/}


                <SkeletonCharts type={type}/>
                {/*<SkeletonCharts type={'fas fa-chart-bar'}/>*/}
                {/*<SkeletonCharts type={'fas fa-chart-area'}/>*/}
            </Row>
        </Skeleton>

    );
};

export default MyTicketSkeleton;
